import { FTLDateUtils } from "ftl-core";
export const createChartFont = (theme) => ({
    fontFamily: theme.typography.tooltip.fontFamily,
    fontSize: `12px`,
    fontWeight: theme.typography.tooltip.fontWeight,
    colors: theme.palette.text.secondary,
});
export const createBasicChartOptions = (theme, opts) => {
    var _a, _b;
    const defaultFont = createChartFont(theme);
    return [
        {
            plotOptions: {
                pie: {
                    expandOnClick: false,
                },
            },
            chart: {
                animations: {
                    enabled: opts.animate,
                    easing: "easeout",
                    speed: 300,
                },
                fontFamily: theme.typography.tooltip.fontFamily,
                locales: [
                    {
                        name: "ru",
                        options: {
                            months: FTLDateUtils.months,
                            shortMonths: FTLDateUtils.months,
                            toolbar: {
                                download: "Скачать",
                                selection: "Выбрать",
                                selectionZoom: "Увеличить выбранное",
                                zoomIn: "Увеличить",
                                zoomOut: "Уменьшить",
                                pan: "Режим просмотра",
                                reset: "Сбросить зум",
                                exportToCSV: ""
                            },
                        },
                    },
                ],
                defaultLocale: "ru",
            },
            markers: {
                hover: {
                    size: Number(opts.showMarkers) * 3,
                },
            },
            tooltip: {
                enabled: !opts.hideTooltip,
            },
            legend: Object.assign(Object.assign({}, defaultFont), { show: !opts.hideLegend, formatter: (_a = opts.formatters) === null || _a === void 0 ? void 0 : _a.legend, labels: {
                    colors: theme.palette.text.secondary,
                }, markers: {
                    width: 30,
                    radius: 0,
                }, itemMargin: {
                    vertical: theme.spacing(3),
                    horizontal: theme.spacing(3),
                } }),
            dataLabels: {
                formatter: (_b = opts.formatters) === null || _b === void 0 ? void 0 : _b.dataLabel,
                enabled: !opts.hideDataLabels,
                background: {
                    borderWidth: 0,
                    padding: 6,
                    dropShadow: {},
                },
                style: Object.assign(Object.assign({}, defaultFont), { colors: undefined }),
            },
            noData: {
                text: opts.noDataText,
                style: Object.assign(Object.assign({}, defaultFont), { fontSize: "24px" }),
            },
        },
        defaultFont,
    ];
};
//# sourceMappingURL=model.js.map